import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '2837709869927533';
const FB_SRC = 'https://connect.facebook.net/en_US/fbevents.js';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Set up the fbq command queue (without depending on an existing <script> tag)
    if (!w.fbq) {
      const fbq: any = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      w.fbq = fbq;
      if (!w._fbq) w._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
    }
    // Inject the fbevents script by appending to <head> (robust in any DOM)
    if (!document.getElementById('meta-pixel-script')) {
      const script = document.createElement('script');
      script.id = 'meta-pixel-script';
      script.async = true;
      script.src = FB_SRC;
      const parent = document.head || document.body || document.documentElement;
      if (parent) parent.appendChild(script);
    }
    // Initialize and track the page view
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return null;
}